import PropTypes from 'prop-types'
import { forwardRef, useEffect, useState } from 'react'
import classNames from 'classnames'
import { noop } from 'utils'

let idIndex = 0

const CheckBox = forwardRef(
  (
    {
      id,
      className = 'box_checkinp',
      checked,
      defaultChecked,
      name = '',
      value = '',
      label = '',
      disabled = false,
      onChange = noop,
      onCheckedChange = noop,
      onClick = noop,
      tiaraAction,
    },
    ref
  ) => {
    const [appliedChecked, setAppliedChecked] = useState(
      checked || defaultChecked
    )
    const [inputChecked, setChecked] = useState(checked || defaultChecked)
    const [uniqIndex] = useState(idIndex++)

    const handleInputChange = e => {
      setChecked(e.target.checked)
      onChange(e)
      onCheckedChange(e.target.checked)
    }

    useEffect(() => {
      setAppliedChecked((checked === undefined ? inputChecked : checked) || '')
    }, [checked, inputChecked])

    return (
      <span
        className={classNames(className, {
          on: appliedChecked,
          in_active: disabled,
        })}>
        <input
          type="checkbox"
          name={name}
          value={value}
          id={id || `checkSet_$$${uniqIndex}`}
          className="inp_check"
          defaultChecked={defaultChecked}
          checked={checked}
          onChange={handleInputChange}
          onClick={onClick}
          ref={ref}
        />
        <label
          htmlFor={id || `checkSet_$$${uniqIndex}`}
          className="lab_check"
          data-tiara-action-name={tiaraAction}>
          <span className="img_comm ico_check" />
          {label}
        </label>
      </span>
    )
  }
)

export default CheckBox

CheckBox.displayName = 'CheckBox'

CheckBox.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onCheckedChange: PropTypes.func,
  onClick: PropTypes.func,
  tiaraAction: PropTypes.string,
}
